module.exports = __webpack_public_path__ + "img/icon_wy10.2b942cb8.png";